import script from "./ColorBets.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorBets.vue?vue&type=script&setup=true&lang=js"

import "./ColorBets.vue?vue&type=style&index=0&id=0a1ea1f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1ea1f6"]])

export default __exports__